//Permissions
export const UPDATE_SECURITY_MODULE_PERMISSIONS = "UPDATE_SECURITY_MODULE_PERMISSIONS"

export const GET_INSURED_INFORMATION_MASTERS_END = "GET_INSURED_INFORMATION_MASTERS_END"
export const GET_SECURITY_MASTERS_END = "GET_SECURITY_MASTERS_END"
export const UPDATE_MODAL_STATE_PARAMS = "UPDATE_MODAL_STATE_PARAMS"

export const UPDATE_USER_SEARCH_RESULT = "UPDATE_USER_SEARCH_RESULT"
export const SHOW_USER_SEARCH_RESULTS = "SHOW_USER_SEARCH_RESULTS"
export const SHOW_USER_TABLE_SEARCH_RESULTS = "SHOW_USER_TABLE_SEARCH_RESULTS"
export const UPDATE_USER_SORT_PARAMETER = "UPDATE_USER_SORT_PARAMETER"
export const CLEAR_USER_SEARCH_PARAMS = "CLEAR_USER_SEARCH_PARAMS"
export const UPDATE_USER_SEARCH_PARAMS = "UPDATE_USER_SEARCH_PARAMS"
export const UPDATE_USER_SEARCH_CHECKBOX_PARAMS = "UPDATE_USER_SEARCH_CHECKBOX_PARAMS"

export const UPDATE_CURRENT_USER_ID = "UPDATE_CURRENT_USER_ID"
export const SHOW_CURRENT_USER_MASTER = "SHOW_CURRENT_USER_MASTER"
export const SHOW_USER_MASTER = "SHOW_USER_MASTER"
export const GET_USER_MASTER_END = "GET_USER_MASTER_END"
export const CLEAR_USER_MASTER_INFORMATION = "CLEAR_USER_MASTER_INFORMATION"
export const UPDATE_USER_MASTER_PARAMS = "UPDATE_USER_MASTER_PARAMS"
export const UPDATE_USER_MASTER_CHECKBOX_PARAMS = "UPDATE_USER_MASTER_CHECKBOX_PARAMS"

export const COLLAPSE_USER_SEARCH_RESULT = "COLLAPSE_USER_SEARCH_RESULT"
export const COLLAPSE_USER_SEARCH = "COLLAPSE_USER_SEARCH"

//Applicable Branches
export const HANDLE_APPLICABLE_BRANCHES_RADIO_BTN_CHANGE = "HANDLE_APPLICABLE_BRANCHES_RADIO_BTN_CHANGE"
export const HANDLE_USER_BRANCHES_RADIO_BTN_CHANGE = "HANDLE_USER_BRANCHES_RADIO_BTN_CHANGE"
export const RESET_APPLICABLE_BRANCHES = "RESET_APPLICABLE_BRANCHES"
export const MOVE_TO_USER_BRANCHES = "MOVE_TO_USER_BRANCHES"
export const REMOVE_FROM_USER_BRANCHES = "REMOVE_FROM_USER_BRANCHES"
export const GET_USER_APPLICABLE_RBANCHES_END = "GET_USER_APPLICABLE_RBANCHES_END"

//User Group Search
export const COLLAPSE_USER_GROUP_SEARCH = "COLLAPSE_USER_GROUP_SEARCH"
export const COLLAPSE_USER_GROUP_SEARCH_RESULT = "COLLAPSE_USER_GROUP_SEARCH_RESULT"
export const UPDATE_USER_GROUP_SEARCH_PARAMS = "UPDATE_USER_GROUP_SEARCH_PARAMS"
export const UPDATE_USER_GROUP_SEARCH_RESULT = "UPDATE_USER_GROUP_SEARCH_RESULT"
export const SHOW_USER_GROUP_SEARCH_RESULTS = "SHOW_USER_GROUP_SEARCH_RESULTS"
export const SHOW_USER_GROUP_TABLE_SEARCH_RESULTS = "SHOW_USER_GROUP_TABLE_SEARCH_RESULTS"
export const UPDATE_USER_GROUP_SORT_PARAMETER = "UPDATE_USER_GROUP_SORT_PARAMETER"

//Group Information
export const SHOW_CURRENT_USER_GROUP = "SHOW_CURRENT_USER_GROUP"
export const SHOW_USER_GROUP = "SHOW_USER_GROUP"
export const UPDATE_CURRENT_GROUP_ID = "UPDATE_CURRENT_GROUP_ID"
export const GET_GROUP_INFO_END = "GET_GROUP_INFO_END"
export const CLEAR_USER_GROUP_INFORMATION = "CLEAR_USER_GROUP_INFORMATION"
export const UPDATE_USER_GROUP_CREATION_PARAMS = "UPDATE_USER_GROUP_CREATION_PARAMS"

//Assign Group Menus
export const GET_SYSTEM_MENUS_END = "GET_SYSTEM_MENUS_END"
export const GET_GROUP_MENUS_END = "GET_GROUP_MENUS_END"
export const RESET_ASSIGN_GROUP_MENUS = "RESET_ASSIGN_GROUP_MENUS"
export const HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_END = "HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_END"
export const HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_FOR_SUBCHILD_END = "HANDLE_SYSTEM_MENU_RADIO_BTN_CHANGE_FOR_SUBCHILD_END"
export const TOGGLE_MENU_OPEN = "TOGGLE_MENU_OPEN"


export const GET_SYSTEM_REPORT_END = "GET_SYSTEM_REPORT_END"
export const GET_GROUP_REPORTS_END = "GET_GROUP_REPORTS_END"
export const RESET_ASSIGN_GROUP_REPORTS = "RESET_ASSIGN_GROUP_REPORTS"
export const HANDLE_SYSTEM_REPORT_RADIO_BTN_CHANGE_END = "HANDLE_SYSTEM_REPORT_RADIO_BTN_CHANGE_END"


export const UPDATE_PASSWORD_PROFILE_PROFILE = "UPDATE_PASSWORD_PROFILE_PROFILE"
export const SHOW_PASSWORD_LISTING_TABLE_SEARCH_RESULTS = "SHOW_PASSWORD_LISTING_TABLE_SEARCH_RESULTS"

export const GET_ALL_PASSWORD_PROFILE_PROFILE_END = "GET_ALL_PASSWORD_PROFILE_PROFILE_END"

export const GET_ALL_PASSWORD_PROFILE_BY_PROFILE_ID_END = "GET_ALL_PASSWORD_PROFILE_BY_PROFILE_ID_END"

export const CLEAR_PASSWORD_PROFILE_PARAMS = "CLEAR_PASSWORD_PROFILE_PARAMS"

//Assign User Groups
export const CLEAR_ASSIGN_USER_GROUP_SEARCH = "CLEAR_ASSIGN_USER_GROUP_SEARCH"
export const UPDATE_ASSIGN_USER_GROUP_SEARCH_PARAMS = "UPDATE_ASSIGN_USER_GROUP_SEARCH_PARAMS"
export const UPDATE_ASSIGN_USER_GROUP_SEARCH_RESULT = "UPDATE_ASSIGN_USER_GROUP_SEARCH_RESULT"
export const SHOW_ASSIGN_USER_GROUP_SEARCH_RESULTS = "SHOW_ASSIGN_USER_GROUP_SEARCH_RESULTS"
export const SHOW_ASSIGN_USER_GROUP_TABLE_SEARCH_RESULTS = "SHOW_ASSIGN_USER_GROUP_TABLE_SEARCH_RESULTS"
export const GET_USER_GROUPS_END = "GET_USER_GROUPS_END"

export const HANDLE_ALL_GROUPS_RADIO_BTN_CHANGE = "HANDLE_ALL_GROUPS_RADIO_BTN_CHANGE"
export const HANDLE_USER_GROUPS_RADIO_BTN_CHANGE = "HANDLE_USER_GROUPS_RADIO_BTN_CHANGE"
export const RESET_USER_GROUPS = "RESET_USER_GROUPS"
export const MOVE_TO_USER_GROUPS = "MOVE_TO_USER_GROUPS"
export const REMOVE_FROM_USER_GROUPS = "REMOVE_FROM_USER_GROUPS"

export const GET_ALL_MENUS_END = "GET_ALL_MENUS_END"

export const GET_ALL_GROUPS_END = "GET_ALL_GROUPS_END"

export const GET_ALL_GROUP_MENUS_END = "GET_ALL_GROUP_MENUS_END"

export const GET_ALL_MODULES_END = "GET_ALL_MODULES_END"

export const GET_ALL_USER_BRANCHES_END = "GET_ALL_USER_BRANCHES_END"

export const CLEAR_GROUP_MENU_PARAMS = "CLEAR_GROUP_MENU_PARAMS"


export const CLEAR_USER_GROUP_SEARCH_PARAMS = "CLEAR_USER_GROUP_SEARCH_PARAMS"